import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Chip,
  Divider,
  CircularProgress,
  Paper,
} from "@mui/material";

const mockTrainings = [
  {
    id: 1,
    title: "Cyber Security Awareness",
    description:
      "Learn about common cyber threats and how to protect company data.",
    type: "pdf",
    duration: 45,
    status: "active",
    createdAt: "2024-01-15",
    assignedEmployees: 78,
    completionRate: 85,
    hasQuiz: true,
    thumbnail:
      "https://images.pexels.com/photos/60504/security-protection-anti-virus-software-60504.jpeg?auto=compress&cs=tinysrgb&w=300",
  },
  {
    id: 2,
    title: "Workplace Safety Guidelines",
    description: "Essential safety protocols and emergency procedures.",
    type: "video",
    duration: 60,
    status: "active",
    createdAt: "2024-01-20",
    assignedEmployees: 156,
    completionRate: 72,
    hasQuiz: true,
    thumbnail:
      "https://images.pexels.com/photos/416978/pexels-photo-416978.jpeg?auto=compress&cs=tinysrgb&w=300",
  },
  {
    id: 3,
    title: "Communication Skills",
    description: "Improve professional communication and presentation skills.",
    type: "link",
    duration: 90,
    status: "draft",
    createdAt: "2024-01-25",
    assignedEmployees: 0,
    completionRate: 0,
    hasQuiz: false,
    thumbnail:
      "https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=300",
  },
];

const TrainingDetails = () => {
  const { id } = useParams();
  const [training, setTraining] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const trainingItem = mockTrainings.find((t) => t.id === Number(id));
    setTraining(trainingItem);
    setLoading(false);
  }, [id]);

  if (loading) {
    return (
      <Box sx={{ p: 4, display: "flex", justifyContent: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!training) {
    return (
      <Box sx={{ p: 4 }}>
        <Typography variant="h5" color="error">
          Training not found.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          {training.title}
        </Typography>

        <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
          <Chip label={training.type.toUpperCase()} color="primary" />
          <Chip label={training.status.toUpperCase()} color="secondary" />
          {training.hasQuiz && <Chip label="Has Quiz" color="warning" />}
        </Box>

        {training.thumbnail && (
          <Box
            component="img"
            src={training.thumbnail}
            alt={training.title}
            sx={{
              width: "100%",
              height: 300,
              objectFit: "cover",
              borderRadius: 2,
              mb: 3,
            }}
          />
        )}

        <Typography variant="body1" sx={{ mb: 2 }}>
          {training.description}
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Typography variant="body2">
          Duration: {training.duration} minutes
        </Typography>
        <Typography variant="body2">
          Assigned Employees: {training.assignedEmployees}
        </Typography>
        <Typography variant="body2">
          Completion Rate: {training.completionRate}%
        </Typography>
        <Typography variant="body2">
          Created At: {new Date(training.createdAt).toLocaleDateString()}
        </Typography>
      </Paper>
    </Box>
  );
};

export default TrainingDetails;
